import { ACCEPT_FILE_EXTENSIONS } from './constants';

export const sharedDefaultProps = {
	accept: ACCEPT_FILE_EXTENSIONS,
	multiple: true
};
